module.exports = {
    pleaseWait:"ကျေးဇူးပြု၍ ခနစောင့်ပါ",
    FAQ:"မေးလေ့ရှိသော မေးခွန်းများ",
    TC:"စည်းကမ်းနှင့်သတ်မှတ်ချက်များ",
    UserGuide:"အသုံးပြုနည်း",
    AccountFAQ:"မေးခွန်း",
    AccountTC:"စည်းမျဉ်း",
    Submit:"ဟုတ်ပြီ",
    change:"‌ပြောင်းရန် ",
    English:"အင်္ဂလိပ်",
    Myanmar:"မြန်မာ",
    Logout:"အကောင့်မှထွက်မည်",
    register:"စာရင်းသွင်းမည်",
    getCode:"ကုဒ်ပြန်တောင်းမည်",
    language0:"ဘာသာစကား",
    language:"ဘာသာစကားရွေးပါ",
    Daily:"နေ့စဉ်",
    Weekly:"အပတ်စဉ်",
    ChancesLeft:"ကျွန်ုပ်၏ပွိုင့်",
    BuyChances:"အကြိမ်ရေဝယ်ရန်",
    BuyMoreChancesCopy:"အခွင့်အရေးများ ထပ်ယူပြီး ဆက်ကစားကာ",
    BuyMoreChancesWin:"ရယူရန်",
    BuyMoreChancesHighlight:"အံ့သြဖွယ်ဆုများ ရယူပါ!",
    CurrentChances:"သင်၏ လက်ရှိအခွင့်အရေးများ:",
    languageTips:"ဘာသာစကားကို ဤနေရာတွင်ရွေးချယ်ပါ",
    loginTips:"ဖုန်းနံပါတ်ထည့်ပါ",
    phoneNumber:"ဖုန်းနံပါတ်",
    select:"ပက်ကေ့ဂျ်တစ်ခု ရွေးချယ်ပါ",
    Monthly:"လစဉ်",
    Level:"အဆင့်",
    Rank:"အဆင့်များ",
    RedeemCenter:"ဆုလဲလှယ်ရန်",
    Categories:"အမျိုးအစားများ",
    HomeNavPrizes:"ဆုများ",
    PrizeWeeklyTitle:"အပတ်စဉ်ဆုများ",
    PrizeMonthlyTitle:"လစဉ်ဆုများ",
    PrizeFirstWinner:"ပထမဆုရှင်",
    PrizeSecondWinner:"ဒုတိယဆုရှင်",
    PrizeThirdWinner:"တတိယဆုရှင်",
    PrizeFourthToTenthWinners:"၄ မှ ၁၀ အဆင့်ဆုရှင်များ",
    PrizeEleventhToTwentiethWinners:"၁၁ မှ ၂၀ အဆင့်ဆုရှင်များ",
    ChooseHere:"ဤနေရာတွင်ရွေးပါ",
    game1T:"AI လေ့ကျင့်မှု",
    game2T2:"အဆင့်ဖြင့်ကစားရန်",
    game3T:"အဖွဲ့လိုက်ပြိုင်ရန်",
    game4T:"အဆုံးမဲ့စိန်ခေါ်ရန်",
    game1C:"သင့်ရဲ့ ထက်မြက်တဲ့ ပါတနာနဲ့ကျွမ်းကျင်မှုတွေကို တိုးတက်အောင် လေ့ကျင့်လိုက်ပါ။",
    game3C:"မိတ်ဆွေများနှင့်အတူ သင်၏အသိပညာကို စစ်ဆေးပါ!",
    game4C2:"မေးခွန်းတစ်ခုစီကို ၁၀စက္ကန့်အတွင်း မှန်ကန်စွာဖြေကြားရပါမည်။ မမှန်ပါက သို့မဟုတ် အချိန်ကုန်ပါက ဂိမ်းသည်ပြီးဆုံးပါမည်။",
    WordQuizAITraining:"AI လေ့ကျင့်မှု",
    WordQuizAITrainingC:"သင့်ရဲ့မေးခွန်းပါတနာ။\nသင့်ကျွမ်းကျင်မှုကို\nမြှင့်တင်ပါ။",
    WordQuizRankedMode:"အဆင့်သတ်မှတ်ပုံစံ",
    WordQuizRankedModeC:"အချိန်နှင့်တပြေးညီ ပြိုင်ဘက်များနှင့် ယှဉ်ပြိုင်ပါ!",
    WordQuizTeamMode:"အဖွဲ့လိုက်ပုံစံ",
    WordQuizTeamModeC:"မိတ်ဆွေများနှင့်အတူ သင်၏အသိပညာကို စိန်ခေါ်ပါ!",
    WordQuizEndlessMode:"အဆုံးမဲ့ပုံစံ",
    WordQuizEndlessModeC:"အဆုံးမဲ့ပုံစံတွင် သင်၏အမြန်နှုန်းနှင့် အသိပညာကို စမ်းသပ်ပါ",
    Ranking:"အဆင့်များ",
    rankList:"အဆင့်စာရင်း",
    RedeemList:"လဲထားသောဆုများ",
    RewardClaimTitle:"သင့်ဆုများ",
    RewardClaimPopupTitle:"ဂုဏ်ယူပါတယ်!",
    RewardClaimPopupContent:"သင် ဆုရရှိထားပါသည်။ ယခုနှိပ်၍ ဆုယူပါ။",
    RewardClaimNow:"ဆုယူမည်",
    RewardClaiming:"ဆုယူနေသည်...",
    RewardNoPending:"လက်ခံရန်စောင့်နေသော ဆုမရှိသေးပါ။",
    RewardExpiresAt:"လက်ခံရမည့်နောက်ဆုံးအချိန်",
    Settings:"ဆက်တင်များ",
    Back:"နောက်သို့",
    game1Tips1:"အဆင့်ရွေးချယ်ပါ",
    Easy:"လွယ်ကူသော",
    Medium:"အလယ်အလတ်",
    Hard:"ခက်ခဲသော",
    RobotMatchMaking:"ကိုက်ညီမှုရှာဖွေခြင်း",
    RobotPlayer:"ကစားသမား",
    RobotAiBot:"AI Bot",
    PlayAgain:"ကစားမည် !",
    WaitingTips:"မိတ်ဆွေများဝင်ရောက်လာရန် စောင့်နေသည်",
    GameOver:"ဂိမ်းပြီးသွားပြီ",
    GameWinTitle:"သင်အနိုင်ရသည်",
    GameLoseTitle:"သင်ရှုံးသည်",
    GameDrawTitle:"သရေ",
    GameWinLead:"အရမ်းကောင်းပါတယ်!",
    GameWinMessage:"သင် ဂိမ်းကို အနိုင်ရခဲ့သည်။",
    GameLoseLead:"အနိုင်ရဖို့ နီးစပ်ခဲ့ပါတယ်!",
    GameLoseMessage:"နောက်တစ်ကြိမ် ကံကောင်းပါစေ။",
    GameDrawMessage:"ပွဲက အကြိတ်အနယ်ဖြစ်ခဲ့သည်။ နှစ်ဦးစလုံး အမှတ်တူပါသည်။",
    SingleQuizOverTitle:"မေးခွန်းများပြီးဆုံးပြီ!",
    SingleQuizOverMessagePrefix:"မေးခွန်းအားလုံး ပြီးဆုံးပါပြီ။ သင်၏",
    SingleQuizOverMessageHighlight:"နောက်ဆုံးရမှတ်ကို ကြည့်ပါ။",
    CreateRoom:"ကစားခန်းဖန်တီးပါ",
    JoinRoom:"ကစားခန်းသို့ဝင်ပါ",
    YourFriend:"သင့်မိတ်ဆွေ",
    RoomID:"ကစားခန်းနံပါတ်",
    enterRoomID:"ကစားခန်းနံပါတ်ထည့်ပါ",
    MatchingLevel:"ကိုက်ညီမှုအဆင့်",
    Waiting:"စောင့်နေသည်",
    Congratulations:"ဂုဏ်ယူပါတယ်၊ သင်အနိုင်ရခဲ့သည်",
    YourScore:"သင့်အမှတ်",
    OpponentScore:"ပြိုင်ဘက်အမှတ်",
    StartNow:"ယခုစမည်!",
    subscribe:'စာရင်းသွင်းမည်',
    subscribeNow:'ယခုပဲ စာရင်းသွင်းမည်',
    notChances:'Not Enough Chances!',
    Later:'နောက်မှ',
    Points:'ပွိုင့်များ',
    Chances:'အကြိမ်ရေ',
    MemberSince:'စာရင်းသွင်းသည့်နေ့',
    currentLevel:'လက်ရှိအဆင့်',
    YouCanRedeem:'သင့်ရဲ့ လဲလှယ်ခွင့်',
    moreTimes:'အကြိမ်ရေ',
    Redeem:'လဲမည်',
    congratulations:'ဂုဏ်ယူပါတယ်',
    redeemTips:'သင်ဆုလဲလှယ်ပါမည်',
  NoRedeemRecords:'ဆုလဲလှယ်သူမရှိသေးပါ၊ ခုပဲ ဂိမ်းကစားပြီး ဆုလဲလှယ်လိုက်ပါ!',
  NoRankList:'အမှတ်ရရှိသူစာရင်းမရှိသေးပါ၊ ခုပဲ ဂိမ်းကစားပြီး စတင်လိုက်ပါ!',
  unsub_tip:'ပယ်ဖျက်လိုပါက OFF ဟု 508 သို့ပို့ပါ။ ',
  Unsubscribe:'စာရင်းပယ်ဖျက်',
  homeGame1T: 'ဉာဏ်စမ်းဂိမ်းများ',
  homeGame1C: 'စိတ်ဝင်စားဖွယ် ပဟေဠိဂိမ်းများကစားပြီး ဉာဏ်စွမ်းအားကို တိုးတက်အောင်လုပ်ပါ။',
  homeGame2T: 'မေးခွန်းဖြေဆိုရန်',
  homeGame2C: 'အမြန်စဉ်းစားပါ!အဖြေ ၃ ခုမှ အဖြေမှန်ကိုရွေးချယ်ပြီး အနိုင်ယူလိုက်ပါ',
  NoGameList: 'ကစားရန်ဂိမ်း မရှိပါ!',
  play: 'ကစားမည်',
  WordQuiz: 'စာလုံးမေးခွန်း',
  GuessWords: 'စကားလုံး ခန့်မှန်းပါ',
  QuizCenterGuessWordsC: 'ပုံကိုကြည့်ပြီး စကားလုံးများကို ခန့်မှန်းလိုက်ပါ။',
  MusicQuiz: 'သီချင်းမေးခွန်း',
  QuizCenterMusicQuizC: 'သီချင်းနားထောင်ပြီး\nသီချင်းအမှန်ကိုရွေးပါ။',
  VideoQuiz: 'ဗီဒီယိုမေးခွန်း',
  QuizCenterVideoQuizC: 'ဗီဒီယိုကိုကြည့်ပြီး\nမှန်သောရုပ်ရှင်ရွေးပါ။',
  next: 'နောက်တစ်ခု',
  image_input_placeholder:"အဖြေမှန်ကို ဤနေရာတွင် ထည့်ပါ။",
  rank:"အဆင့်",
  no_data:"ဒေတာမရှိပါ",
  sharePanelTitle:'သူငယ်ချင်းများထံ မျှဝေပါ',
  sharePanelTips:'အောက်ပါ platform များထဲမှ တစ်ခုကိုရွေးပြီး invite link ကို တိုက်ရိုက်ပို့လိုက်ပါ။',
  shareMore:'အခြား App များသို့ မျှဝေမယ်',
  invitation:'ဖိတ်ကြားချက်',
  copy:'မိတ္တူကူးပါ',
  CopySucceeded:'ကူးယူပြီးပါပြီ',
  referralTips1:"စိတ်ဝင်စားစရာတစ်ခုတွေ့လို့ ခင်ဗျားနဲ့ မျှဝေချင်ပါတယ်။ လာပါ၊ ကျွန်တော်နဲ့ ပူးပေါင်းပါ။",
  AnnouncementPopupTitle:'ကြေငြာချက်',
  AnnouncementPopupContent:'ဩဂုတ်လမှစတင်၍ Rank 1 မှ 50 အတွင်းရှိသူများထဲမှ အနိုင်ရရှိသူ ၃ ဦးကို ကျပန်းရွေးချယ်ပြီး အထူးဆုများအဖြစ် ကျပ် ၁၅ သိန်း၊ ကျပ် ၁၀ သိန်းနှင့် ကျပ် ၅ သိန်း အသီးသီး ပေးအပ်သွားမည်ဖြစ်ပါသည်။',
  AnnouncementPopupAction:'စတင်မည်',
  AnnouncementPopupClose:'ကြေညာချက်ကို ပိတ်ရန်',
  one_time_purchase:"ဂိမ်းကစားခွင့် (၁) ကြိမ်",
  LiveQuiz:'တိုက်ရိုက် ဉာဏ်စမ်း',
  Questions:'မေးခွန်းများ',
  Question:'မေးခွန်း',
  LiveQuizStartsAt:'စတင်မည့်အချိန်',
  LiveQuizStartsIn:'စတင်ရန် ကျန်ချိန်',
  LiveQuizReserveEndsIn:'ကြိုတင်စာရင်းပိတ်ရန် ကျန်ချိန်',
  LiveQuizReserve:'အခမဲ့ ကြိုတင်စာရင်းပေးမည်',
  LiveQuizReserved:'ကြိုတင်စာရင်းပေးပြီးပါပြီ',
  LiveQuizReservationClosed:'ကြိုတင်စာရင်းပိတ်သွားပါပြီ',
  LiveQuizEnterLobby:'စောင့်ဆိုင်းခန်းသို့ ဝင်မည်',
  LiveQuizEnter:'တိုက်ရိုက် ဉာဏ်စမ်းသို့ ဝင်မည်',
  LiveQuizSpectatorHint:'သင်သည် ကြည့်ရှုသူဖြစ်သောကြောင့် မေးခွန်းဖြေဆို၍မရပါ။',
  LiveQuizAnswerReveal:'အဖြေပြသချိန်',
  LiveQuizParticipationGift:'ပါဝင်မှုလက်ဆောင်',
  LiveQuizParticipatedQuestions:'သင်သည် မေးခွန်း {count} ခုတွင် ပါဝင်ဖြေဆိုခဲ့ပါသည်',
  LiveQuizGiftSurprise:'အံ့အားသင့်ဖွယ်ဆုကို ရယူပါ',
  LiveQuizGiftBox:'လက်ဆောင်သေတ္တာ',
  LiveQuizGiftUpToPoints:'ပွိုင့် {points} အထိ',
  LiveQuizGiftClaiming:'ရယူနေသည်...',
  LiveQuizContinueSpectating:'သိပါပြီ၊ ဆက်လက်ကြည့်ရှုမည်',
  LiveQuizRemindTomorrow:'မနက်ဖြန် ရယူရန် သတိပေးပါ',
  LiveQuizCloseGift:'လက်ဆောင်သေတ္တာကို ပိတ်မည်',
  LiveQuizPointsReceived:'ပွိုင့် {points} ရရှိပါသည်',
  LiveQuizEnded:'ဤအကျော့ ပြီးဆုံးသွားပါပြီ',
  LiveQuizConnectionError:'တိုက်ရိုက် ဉာဏ်စမ်းနှင့် ချိတ်ဆက်မရပါ',
  LiveQuizReconnectHint:'ချိတ်ဆက်မှု ပြတ်တောက်သွားပါသည်။ ဆက်လက်ရန် ပြန်လည်ချိတ်ဆက်ပါ။',
  LiveQuizReconnect:'ပြန်လည်ချိတ်ဆက်မည်',
  LiveQuizReadyPlayers:'{count} ဦး အဆင်သင့်ဖြစ်နေပါသည်',
  LiveQuizReadyTitle:'တိုက်ရိုက် ဉာဏ်စမ်းအတွက် အဆင်သင့်ဖြစ်ပါပြီ',
  LiveQuizChallenge:'ဉာဏ်စမ်း စိန်ခေါ်မှု',
  LiveQuizSchedule:'တိုက်ရိုက် ဉာဏ်စမ်း အချိန်ဇယား',
  LiveQuizHistory:'မှတ်တမ်း',
  LiveQuizToday:'ယနေ့',
  LiveQuizTomorrow:'မနက်ဖြန်',
  LiveQuizStartingSoon:'မကြာမီ စတင်မည်',
  LiveQuizNoRounds:'ဤနေ့အတွက် အကျော့များ မရှိသေးပါ။',
  LiveQuizLoadMore:'ထပ်မံကြည့်မည်',
  LiveQuizLoading:'ဖွင့်နေသည်...',
  LiveQuizPeople:'ဦး',
  LiveQuizClearedLevel:'ဤအကျော့ကို ဖြတ်ကျော်နိုင်ခဲ့သည်။',
  LiveQuizBackToSchedule:'အချိန်ဇယားသို့ ပြန်သွားမည်',
  LiveQuizStatusEnded:'ပြီးဆုံးပြီ',
  LiveQuizStatusBooking:'စာရင်းပေးနိုင်',
  LiveQuizStatusReserved:'စာရင်းပေးပြီး',
  LiveQuizStatusPreview:'ကြိုတင်ကြည့်ရှု',
  LiveQuizStatusStarting:'မကြာမီစမည်',
  LiveQuizStatusClosed:'ပိတ်ထားသည်',
  LiveQuizMaxRewardHint:'မေးခွန်း {count} ခုလုံးဖြေပြီး ရယူရန်',
  LiveQuizPassedPlayers:'{count} ဦး ဖြတ်ကျော်ခဲ့သည်',
  LiveQuizStatusStarted:'စတင်နေပြီ',
  LiveQuizUnableToJoin:'ဝင်ရောက်၍ မရတော့ပါ',
  LiveQuizMissedEntry:'ဤအကျော့ စတင်နေပြီဖြစ်သည်။ မစတင်မီ စောင့်ဆိုင်းခန်းသို့ မဝင်ရောက်ခဲ့သော ကစားသမားများ အလယ်တွင် ဝင်ရောက်၍ မရတော့ပါ။',
  LiveQuizLobbyAvailableInTenMinutes:'ဉာဏ်စမ်းမစတင်မီ ၁၀ မိနစ်အလိုတွင် စောင့်ဆိုင်းခန်းသို့ ဝင်ရောက်နိုင်ပါသည်။',
  LiveQuizTomorrowReservedHint:'ဉာဏ်စမ်းမစတင်သေးပါ။ မနက်ဖြန် ပါဝင်ရန် မမေ့ပါနှင့်။',
  LiveQuizNotStarted:'မစတင်သေးပါ',
  LiveQuizWinnerInfo:'ဆုရရှိသူ အချက်အလက်',
  LiveQuizWinnerReceived:'{name} သည် {points} ပွိုင့် ရရှိသည်',
  LiveQuizRound:'အကျော့',
  LiveQuizUltimateQuiz:'အဆုံးစွန် ဉာဏ်စမ်း',
  LiveQuizHome:'ပင်မစာမျက်နှာ',
  LiveQuizWinYourPrizes:'သင့်ဆုများကို ရယူပါ',
  LiveQuizRoundOver:'အကျော့ပြီးဆုံးပါပြီ',
  LiveQuizCalculatingPassRewards:'အောင်မြင်သူဆုများကို တွက်ချက်နေသည်...',
  LiveQuizNextMatch:'နောက်အကျော့ {time}',
  LiveQuizPts:'pts',
  LiveQuizLoyalty:'Loyalty',
  LiveQuizAveragePassReward:'အနိုင်ရသူတစ်ဦးလျှင် ပျမ်းမျှဆု',
  LiveQuizTimeRemainingToStart:'စတင်ရန်ကျန်ရှိချိန်',
  LiveQuizMinute:'မိနစ်',
  LiveQuizSecond:'စက္ကန့်',
  LiveQuizParticipants:'{count} ဦး ပါဝင်နေသည်',
  LiveQuizPrizePool:'ဤပွဲ၏ ဆုကြေးမှာ',
  LiveQuizCompleteAllToShare:'မေးခွန်း {count} ခုလုံး ဖြေဆိုပြီး ဆုကို ခွဲဝေရယူပါ။',
  LiveQuizPleasePrepare:'ကျေးဇူးပြု၍ အသင့်ပြင်ထားပါ',
  LiveQuizSelected:'ရွေးချယ်ပြီး',
  LiveQuizSelectedHint:'သင် ရွေးချယ်ပြီးပါပြီ။ အချိန်ရေတွက်မှု ပြီးဆုံးသည့်အခါ အဖြေမှန်ကို ပြသပါမည်။',
  LiveQuizChooseAnswer:'အချိန်မကုန်မီ အဖြေတစ်ခု ရွေးချယ်ပါ။',
  LiveQuizCorrectNextQuestion:'အဖြေမှန်ပါသည်။ နောက်မေးခွန်းကို {seconds} စက္ကန့်အတွင်း ပြသပါမည်။',
  LiveQuizWrongContinueSpectating:'အဖြေမှားပါသည်။ ဆက်လက်ကြည့်ရှုနိုင်ပါသည်။',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js